export enum PositionApprovalStatesEnum {
  APPROVED = 'APPROVED',
  WAITING_APPROVAL = 'WAITING_APPROVAL'
}
